import { useEffect, useRef, useState } from 'react';

export function useDebounced<T>(
  value: T,
  waitMilliseconds = 50,
  leading = true
): T {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const debounced = useRef<any>(null);
  const resetTimeout = useRef<any>(null);
  const isFirstRun = useRef(true);

  useEffect(() => {
    const immediate = leading && isFirstRun.current;
    if (isFirstRun.current) {
      isFirstRun.current = false;
    }
    if (immediate) {
      setDebouncedValue(value);
    }
    debounced.current = setTimeout(() => {
      if (!immediate) {
        setDebouncedValue(value);
      }
      resetTimeout.current = setTimeout(() => {
        isFirstRun.current = true;
      }, waitMilliseconds);
    }, waitMilliseconds);
    return () => {
      if (debounced.current) {
        clearTimeout(debounced.current);
      }
      if (resetTimeout.current) {
        clearTimeout(resetTimeout.current);
      }
    };
  }, [value, waitMilliseconds, leading]);

  return debouncedValue;
}
